import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Route } from "react-router-dom";

//btc rates
class BtcRates extends Component {
  state = {
    id: "",
    min: "",
    max: "",
    amount: "",
    loading: false,
    current_rates: [],
  };

  componentDidMount() {
    this.get_data();
  }

  get_data = async () => {
    await axios.get("/btrades/btc_rates").then((resp) => {
      this.setState({
        current_rates: resp.data.data,
      });
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onEdit = (data) => {
    this.setState({
      id: data._id,
      min: data.min,
      max: data.max,
      amount: data.amount,
    });
  };

  handleSubmit = (e) => {
    this.setState({
      loading: true,
    });
    e.preventDefault();
    if (this.state.id) {
      axios
        .put(`/btrades/btc_rate/${this.state.id}`, {
          min: this.state.min,
          max: this.state.max,
          amount: this.state.amount,
        })
        .then((resp) => {
          toast(resp.data.message);
          document.getElementById("notification").reset();
          this.setState({
            id: "",
            min: "",
            max: "",
            amount: "",
            loading: false,
          });
        })
        .catch((e) => {
          this.setState({
            loading: false,
          });
        });
    } else {
      axios
        .post("/btrades/new_btc_rate", {
          min: this.state.min,
          max: this.state.max,
          amount: this.state.amount,
        })
        .then((resp) => {
          toast(resp.data.message);
          document.getElementById("notification").reset();
          this.setState({
            loading: false,
          });
        })
        .catch((e) => {
          this.setState({
            loading: false,
          });
        });
    }
  };

  render() {
    const current_rates = this.state.current_rates;

    return (
      <div className="row container">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Min</th>
              <th scope="col">Max</th>
              <th scope="col">Amount</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {current_rates &&
              current_rates.map((rate) => {
                return (
                  <tr>
                    <td>{rate.min}</td>
                    <td>{rate.max}</td>
                    <td>{rate.amount}</td>
                    <td>
                      <button
                        className="btn btn-success"
                        type="submit"
                        disabled={this.state.loading}
                        onClick={() => this.onEdit(rate)}
                      >
                        edit
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <div className="col-md-6 offset-md-3" style={{ marginTop: 50 + "px" }}>
          <div
            className="card card-register mx-auto mt-2"
            style={{ border: 0, borderRadius: 0, marginBottom: 10 + "%" }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: "white",
                borderBottom: 0,
                marginTop: 2 + "%",
                fontWeight: "bold",
              }}
            >
              New Rate
            </div>
            <hr
              style={{
                marginRight: 20 + "px",
                marginLeft: 20 + "px",
                marginTop: 0,
                marginBottom: 0,
              }}
            />
            <div className="card-body">
              <form onSubmit={this.handleSubmit} id="notification">
                <input
                  name="min"
                  type="text"
                  className="mt-3 form-control"
                  placeholder="Min"
                  onChange={this.handleChange}
                  defaultValue={this.state.min}
                  required
                />
                <input
                  name="max"
                  type="text"
                  className="mt-3 form-control"
                  placeholder="Max"
                  onChange={this.handleChange}
                  defaultValue={this.state.max}
                  required
                />
                <input
                  name="amount"
                  type="text"
                  className="mt-3 form-control"
                  placeholder="Amount"
                  onChange={this.handleChange}
                  defaultValue={this.state.amount}
                  required
                />

                <button
                  className="btn btn-success mt-3"
                  type="submit"
                  disabled={this.state.loading}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BtcRates;
